import { useMemo, useSyncExternalStore } from "react";

import type { SessionView } from "src/api";

import { useGame } from "./GameContext";

export function useSessionView(): SessionView | null {
  const { session } = useGame();

  const subscribe = (onChange: () => void) =>
    session ? session.subscribe(onChange) : () => {};

  const getRevision = () => (session ? session.revision : -1);

  const revision = useSyncExternalStore(subscribe, getRevision, getRevision);

  // `revision` is the cache key: view() reads the session, which the linter cannot see change.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  return useMemo(() => session?.view() ?? null, [session, revision]);
}
